import type { MHeading_ThemeProp } from '../MHeading';

export interface TitleOptions {
  title: string;
  theme: MHeading_ThemeProp;
}
export const isTitleOption = (v: unknown): v is TitleOptions =>
  typeof v === 'object' && Object.prototype.hasOwnProperty.call(v, 'title');
